import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { WorkflowType } from 'modules/workflows/enums';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { WorkflowsRootState } from '../ducks.types';

export const getWorkflowType = (
  state: WorkflowsRootState,
): { isDraft: boolean; isPublished: boolean; draftOnly: boolean } => {
  const workflow = state.workflow?.workflow || {};
  const workflowType = workflow?.workflowType;
  const workflowReference = workflow?.workflowReference;
  return {
    isDraft: workflowType === WorkflowType.DRAFT,
    isPublished: workflowType === WorkflowType.PUBLISHED,
    // if workflow only exists as a draft, has not been published
    draftOnly: workflowReference === null && workflowType === WorkflowType.DRAFT,
  };
};

export const getIsNodeEditorReadOnly = (state: WorkflowsRootState) => {
  const canDraftMessaging = selectDoesUserHaveRbacPermission(state)(
    PROJECT_PERMISSIONS.DraftMessaging,
  );
  const isNodeEditorAsyncLoading = state.workflow?.isNodeEditorAsyncLoading;
  const { isPublished } = getWorkflowType(state);

  return !canDraftMessaging || isNodeEditorAsyncLoading || isPublished;
};
